import React from 'react';

import { Text } from '../Text';
import { normalizeHexCode } from '~/styles/utils';

interface PlansIconProps {
  name: string;
  title: string;
  replaceWithText?: string | null;
  textClasses?: string;
  redesign20?: boolean;
  iconColor?: string;
  iconClasses?: string;
}

export enum plansEnum {
  CORE = 'Core',
  MAX = 'Max',
  INFINITY = 'Infinity',
  INVEST = 'Greenlight + Invest'
}

export const getRewardByPlan = (name: string) => {
  switch (name) {
    case plansEnum.MAX:
      return 2;

    case plansEnum.INFINITY:
      return 5;

    case plansEnum.CORE:
    default:
      return 1;
  }
};

export default function PlansIcon({
  name,
  title,
  replaceWithText,
  textClasses = 'text-base font-medium text-[#1D252C] max-w-[200px]',
  redesign20 = false,
  iconColor = '',
  iconClasses = ''
}: PlansIconProps) {
  if (replaceWithText) {
    return (
      <Text as="h3" className={textClasses} data-testid={`${name}-plan-text`}>
        {replaceWithText}
      </Text>
    );
  } else {
    if (redesign20) {
      return (
        <svg
          width="16"
          height="17"
          className={iconClasses}
          viewBox="0 0 16 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_14095_3982)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0.666748 8.28988C0.666748 4.24654 3.95675 0.956543 8.00008 0.956543C12.0434 0.956543 15.3334 4.24654 15.3334 8.28988C15.3334 12.3332 12.0434 15.6232 8.00008 15.6232C3.95675 15.6232 0.666748 12.3332 0.666748 8.28988ZM4.33343 8.47057L7.67899 11.2898L11.6668 6.44077L10.0283 5.28985L7.40248 8.48262L5.7201 7.06474L4.33343 8.47057Z"
              fill={normalizeHexCode(iconColor)}
            />
          </g>
          <defs>
            <clipPath id="clip0_14095_3982">
              <rect
                width="16"
                height="16"
                fill="white"
                transform="translate(0 0.290039)"
              />
            </clipPath>
          </defs>
        </svg>
      );
    } else {
      return (
        <svg
          data-testid={`${name}-${title}`}
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="28"
          viewBox="0 0 22 24"
          fill="none"
        >
          <path
            d="M3.66675 12.0387L8.68987 17.5184L18.3334 7"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    }
  }
}
